module.exports = __webpack_public_path__ + "img/grupowe.793095c5.jpg";